import {jsonMember, jsonObject} from "typedjson";

/** Условие сортировки */

@jsonObject
export class PitRequestCriteriaSort {

  /** Наименование поля для сортировки */
  @jsonMember({name: "field", constructor: String, emitDefaultValue: false, isRequired: false })
  private _field: string;

  /** Направление сортировки: asc, desc */
  @jsonMember({name: "direction", constructor: String, emitDefaultValue: false, isRequired: false })
  private _direction: string;

  /** Чувствительность к регистру */
  @jsonMember({name: "caseSens", constructor: Boolean, emitDefaultValue: false, isRequired: false })
  private _caseSens: boolean;


  get field(): string {
    return this._field;
  }

  set field(value: string) {
    this._field = value;
  }

  get direction(): string {
    return this._direction;
  }

  set direction(value: string) {
    this._direction = value;
  }

  get caseSens(): boolean {
    return this._caseSens;
  }

  set caseSens(value: boolean) {
    this._caseSens = value;
  }

  constructor(fields?: Partial<PitRequestCriteriaSort>) {
    if (fields)
      Object.assign(this, fields);
  }
}
